import { render } from "./NavigationComponent.vue?vue&type=template&id=38c27f54&scoped=true"
import script from "./NavigationComponent.vue?vue&type=script&lang=js"
export * from "./NavigationComponent.vue?vue&type=script&lang=js"

import "./NavigationComponent.vue?vue&type=style&index=0&id=38c27f54&scoped=true&lang=css"

import exportComponent from "/Users/dmitriy-pc/Projects/docs.d-services.ru/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-38c27f54"]])

export default __exports__